import React from 'react';

import { Button, Typography } from '@mui/material';

import strings from '../../localization';

interface IManualSignupPolicyAcceptance {
  onOperationalBriefingClick: () => void;
  onWorkEthicsClick: () => void;
}

const linkButtonStyle = {
  fontSize: '1rem',
  fontWeight: 'bold',
  minWidth: 0,
  padding: 0,
  textDecoration: 'underline',
  textTransform: 'none',
  verticalAlign: 'baseline',
};

const ManualSignupPolicyAcceptance = ({
  onOperationalBriefingClick,
  onWorkEthicsClick,
}: IManualSignupPolicyAcceptance) => {
  const createClickHandler = (onClick: () => void) =>
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      event.stopPropagation();
      onClick();
    };

  return (
    <Typography component="span" fontSize="1rem" fontWeight={400}>
      {strings.reviewPoliciesPrefix}
      <Button
        onClick={createClickHandler(onOperationalBriefingClick)}
        sx={linkButtonStyle}
        type="button"
        variant="text"
      >
        {strings.operationalBriefing}
      </Button>
      {strings.reviewPoliciesBetween}
      <Button
        onClick={createClickHandler(onWorkEthicsClick)}
        sx={linkButtonStyle}
        type="button"
        variant="text"
      >
        {strings.workEthics}
      </Button>
      {strings.reviewPoliciesSuffix}
    </Typography>
  );
};

export default ManualSignupPolicyAcceptance;
